// extracted by mini-css-extract-plugin
export default {"ButtonContainer":"styles_ButtonContainer__MdqgY","Button":"styles_Button__Gjtdz"};